"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ListGroupCardsComponent extends Marko.Component {
}
exports.default = ListGroupCardsComponent;
